import { create } from 'apisauce'

const api = create({
    baseURL: 'https://empa-ba.americatrack.com/api/',
});

export default api; 
